export default __webpack_public_path__ + "static/media/nodata.6399b200.svg";